import { render } from "./InventoryAddModal.vue?vue&type=template&id=c1d114ee"
import script from "./InventoryAddModal.vue?vue&type=script&lang=js"
export * from "./InventoryAddModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__